import * as React from 'react';
import { ITooltipProps } from './tooltip-props';
import MuiTooltip from '@mui/material/Tooltip';

export function Tooltip(props: ITooltipProps) {
  const { children, ...rest } = props;
  return <MuiTooltip {...rest}>{children}</MuiTooltip>;
}
